import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { base64StringToBlob } from 'blob-util';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { element } from 'protractor';
import { Subject, catchError, throwError } from 'rxjs';
import { config } from 'src/app/config/config';
import { AppService } from 'src/app/service/app.service';
import { PNoteService } from 'src/app/service/pnote.service';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { DatatableService } from 'src/app/service/datatable.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
declare var $: any;
pdfMake.vfs = pdfFonts.vfs;

@Component({
  selector: 'app-upload-annexure',
  templateUrl: './upload-annexure.component.html',
  styleUrls: ['./upload-annexure.component.css']
})

export class UploadAnnexureComponent implements OnInit {

  pNoteForm: FormGroup;
  pNoteComment: FormGroup;
  monthArray: string[] = Array.from({ length: 12 }, (_, i) => new Date(2000, i).toLocaleDateString('en', { month: 'long' }));
  submitted = false;
  user: any = {};
  entityType: String;
  action: string = 'add';
  config: any = config;
  access: any = {};
  bsValue: any;
  bsValue1: any;
  isFileUploaded: boolean = false;
  file: any;
  fileName: any;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  zipFileResponse: any = {};
  csvFileResponse: any = {};
  xlsxFileError: boolean = false;
  showFileFields: boolean = false;
  showMonthDropdown: boolean = false;
  userDetails: any = {};

  annexureSet: Set<string> = new Set();
  instrumentSet: Set<string> = new Set();

  annexureInstrumentList: any = {};
  annxAList: any = [];
  annxBList: any = [];
  annxBListCurrent: any = [];
  annxBDerivativeList: any = [];
  annxCList: any = [];
  annxCListCurrent: any = [];
  annxCDerivativeList: any = [];
  annxDList: any = [];
  annxEList: any = [];
  showApproveReject: boolean = false;
  annxErrorList: any = [];
  withinCutoffDate: boolean = false;

  entityCode: String;
  previousMonth: String;
  year: number;
  lastDateofPreviousMonth: number;
  masterId: String;

  isValidFileUploaded: boolean = true;

  showAnnexureBTable: boolean = false;
  showAnnexureCTable: boolean = false;
  derivativeBFlag: boolean = false;
  derivativeCFlag: boolean = false;

  submittedPNotesID: String = null;
  submittedPNotes: any = {};

  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;

  @ViewChild('file', { static: false })
  fileInput: ElementRef;

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private titleService: Title,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
    private appService: AppService,
    private pNoteService: PNoteService,
    private dataTableService: DatatableService) {
    this.route.queryParams.subscribe(params => {
      if (params['id']) {
        this.submittedPNotesID = params['id'];
      }
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle('ODI Submission');
    $('.selectpicker').selectpicker();
    this.userDetails = this.userDetailsService.getUserDetails();
    this.entityType = this.userDetails.entityType;
    this.pNoteForm = this.formBuilder.group({
      annexureFile: [null, Validators.required]
    });
    this.pNoteComment = this.formBuilder.group({
      comment: []
    });
    this.getAnxrInstDetails();

    if (new Date().getMonth() - 1 < 0) {//check for December if current month is January
      this.previousMonth = this.monthArray[11];
      this.year = new Date().getFullYear() - 1;
    } else {
      this.previousMonth = this.monthArray[new Date().getMonth() - 1];
      this.year = new Date().getFullYear();
    }
    this.lastDateofPreviousMonth = new Date(this.year, new Date().getMonth(), 0).getDate();

  }

  ngAfterViewInit(): void {
    $('.selectpicker').selectpicker('refresh');
  }

  get f() { return this.pNoteForm.controls; }

  get cf() { return this.pNoteComment.controls; }

  onChange(event) {
    if (event.target.files && event.target.files[0]) {
      this.file = event.target.files[0];
      this.fileName = event.target.files[0].name;
      this.isFileUploaded = true;
      if (this.file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && this.file.size <= 10000000) {
        this.xlsxFileError = false;
      } else {
        this.xlsxFileError = true;
      }
    }
  }

  setInitDataAnnxBC() {
    this.onChangeAnnxInst(this.instrumentSet.entries().next().value[0], 'Annexure B');
    this.onChangeAnnxInst(this.instrumentSet.entries().next().value[0], 'Annexure C');
  }

  onChangeAnnxInst(data, annxType: String) {
    if (annxType == 'Annexure B') {
      this.derivativeBFlag = (data == 'Derivative') ? true : false;
      let filteredData = this.annxBList.filter(element => element.anxrInstType == data);
      this.showAnnexureBTable = true;
      this.annxBListCurrent.length = 0;
      if (this.annxBListCurrent.length == 0) {
        this.annxBListCurrent.push(...filteredData)
      }
      if (this.derivativeBFlag == true) {
        this.dataTableService.setDatatable("annexureB", 6, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureBDerivative", 6, 10, [10, 25, 50, 100]);
      } else if (this.derivativeBFlag == false) {
        this.dataTableService.setDatatable("annexureBDerivative", 6, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureB", 6, 10, [10, 25, 50, 100]);
      }
    } else if (annxType == 'Annexure C') {
      this.derivativeCFlag = (data == 'Derivative') ? true : false;
      let filteredData = this.annxCList.filter(element => element.anxrInstType == data);
      this.showAnnexureCTable = true;
      this.annxCListCurrent.length = 0;
      if (this.annxCListCurrent.length == 0) {
        this.annxCListCurrent.push(...filteredData)
      }
      if (this.derivativeCFlag == true) {
        this.dataTableService.setDatatable("annexureC", 5, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureCDerivative", 6, 10, [10, 25, 50, 100]);
      } else if (this.derivativeCFlag == false) {
        this.dataTableService.setDatatable("annexureCDerivative", 6, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureC", 5, 10, [10, 25, 50, 100]);
      }
    }
  }

  removeFile(type) {
    this.fileInput.nativeElement.value = null;
    this.f.annexureFile.reset();
    this.isFileUploaded = false;
    this.file = null;
    this.fileName = '';
    this.cdref.detectChanges();
  }

  getAnxrInstDetails() {
    this.pNoteService.getAnxrInstDetails().pipe(catchError((error: any) => {
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.annexureInstrumentList = response.data;
        for (let i = 0; i < response.data.length; i++) {
          this.annexureSet.add(response.data[i].anxrType)
          if (response.data[i].anxrType == 'Annexure B' || response.data[i].anxrType == 'Annexure C') {
            this.instrumentSet.add(response.data[i].anxrInstType)
          }
        }
        if (this.submittedPNotesID != 'newRequest') {
          this.getSubmittedPNotes();
        } else {
          this.dataTableService.setDatatable("annexureA", 35, 10, [10, 25, 50, 100]);
          this.dataTableService.setDatatable("annexureD", 10, 10, [10, 25, 50, 100]);
          this.dataTableService.setDatatable("annexureE", 17, 10, [10, 25, 50, 100]);
          this.setInitDataAnnxBC();
          this.getSubmissionDueDate();
        }
        this.cdref.detectChanges();
        $('.selectpicker').selectpicker('refresh');
      }
    })
  }

  getSubmissionDueDate() {
    this.pNoteService.getSubmissionDueDate().pipe(catchError((error: any) => {
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {

        this.withinCutoffDate = new Date().getDate() <= response.data ? true : false;

        $('.selectpicker').selectpicker('refresh');
      }
    })
  }

  downloadSampleAnnexure() {
    this.pNoteService.downloadSampleFile().pipe(catchError((error: any) => {
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        let file = response.data;
        let contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        let blob = base64StringToBlob(file, contentType);
        saveAs(blob, "Sample_ODI_Annexure", { autoBOM: true });
      } else {
        this.toastr.error(response.message);
      }
    })
  }

  getSubmittedPNotes() {
    let requestObject = {
      "pnotesID": this.submittedPNotesID
    }
    this.pNoteService.getSubmittedPNotes(requestObject).pipe(catchError((error: any) => {
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.submittedPNotes = response.data[0];
        if (this.submittedPNotes.status == 'SUBMITTED' && this.submittedPNotes.makerId != this.userDetails.loginId) {
          this.showApproveReject = true;
        }
        this.isValidFileUploaded = true;
        this.submittedPNotesID = this.submittedPNotes.pnotesID;
        this.annxAList = this.submittedPNotes.annexureA;
        this.annxBList = this.submittedPNotes.annexureB;
        this.annxCList = this.submittedPNotes.annexureC;
        this.annxDList = this.submittedPNotes.annexureD;
        this.annxEList = this.submittedPNotes.annexureE;
        this.dataTableService.setDatatable("annexureA", 35, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureD", 10, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureE", 17, 10, [10, 25, 50, 100]);
        this.setInitDataAnnxBC()
        $('.selectpicker').selectpicker('refresh');
      }
    })
  }

  uploadAnnexure() {
    // this.spinner.show();
    this.pNoteService.uploadAnnexure(this.file, this.submittedPNotesID).pipe(catchError((error: any) => {
      // this.spinner.hide();
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200 && error.status != 206) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      this.spinner.hide();
      this.removeFile('xlsx')
      if (response.statusCode == 200) {
        this.toastr.success("File uploaded successfully !!");
        this.isValidFileUploaded = true;
        this.submittedPNotes = response.data;
        this.submittedPNotesID = response.data.pnotesID;
        this.annxAList = response.data.annexureA;
        this.annxBList = response.data.annexureB;
        this.annxCList = response.data.annexureC;
        this.annxDList = response.data.annexureD;
        this.annxEList = response.data.annexureE;
        this.dataTableService.setDatatable("annexureA", 35, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureD", 10, 10, [10, 25, 50, 100]);
        this.dataTableService.setDatatable("annexureE", 17, 10, [10, 25, 50, 100]);
        this.setInitDataAnnxBC();
        $('.selectpicker').selectpicker('refresh');
      } else if (response.statusCode == 206) {
        this.annxErrorList = response.data;
        this.isValidFileUploaded = false;
        this.toastr.warning(response.message);
        this.dataTableService.setDatatable("errorTable", 5, 10, [10, 25, 50, 100]);
        $('.selectpicker').selectpicker('refresh');
      } else if (response.statusCode == 409) {
        this.toastr.error(response.message);
      } else {
        this.toastr.error("Invalid File uploaded !!");
      }
    })
  }

  back() {
    this.router.navigate(['/securities/odi']);
  }

  confirmPNoteAnnexureByMaker() {
    this.pNoteService.confirmPNoteAnnexureByMaker(this.submittedPNotes).pipe(
      catchError((error: any) => {
        // this.spinner.hide();
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200 && error.status != 206) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {

        this.submittedPNotes = response.data;
        this.toastr.success("Annexure Submitted Successfully!!");
        this.router.navigate(['../'], { relativeTo: this.route, skipLocationChange: true });
      }
      else {
        this.toastr.error("Failure to submit ODI Annexure !!");
      }
    })
  }

  confirmPNoteAnnexureByChecker(status) {
    let reqObj = {
      reqId: this.submittedPNotes.pnotesID,
      comment: this.cf.comment.value,
      status: status
    }
    this.pNoteService.confirmPNoteAnnexureByChecker(reqObj).pipe(catchError((error: any) => {
      // this.spinner.hide();
      this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
      if (error.status != 200 && error.status != 206) {
        return throwError(error.error);
      }
    })).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
        this.toastr.success("Annexure Submitted Successfully!!");
        this.router.navigate(['../'], { relativeTo: this.route, skipLocationChange: true });
      } else {
        this.toastr.error("Failure to submit ODI Annexure!!");
      }
    })
  }

}
